import { useLingui } from '@lingui/react/macro'
import * as Dialog from '@radix-ui/react-dialog'
import CantileverButton from 'components/CantileverButton'
import CantileverCard from 'components/CantileverCard'
import { X } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

import { TermsContent } from './TermsContent'

const ModalOverlay = styled(Dialog.Overlay)<{ $requiredToAccept: boolean }>`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${({ $requiredToAccept }) =>
    $requiredToAccept ? 'black' : 'rgba(0, 0, 0, 0.5);'};
  justify-content: center;
  align-items: center;
  z-index: 10000000;
  height: 100vh;
  width: 100vw;
`

const ModalContent = styled(Dialog.Content)`
  width: 50%;
  height: 80%;
  border-radius: 0.5rem;

  &:focus,
  &:focus-visible {
    outline: none;
  }
`

const AcceptButton = styled(CantileverButton)`
  width: 100%;
`

interface TermsModalProps {
  requiredToAccept: boolean
  onAccept: () => void
  onClose: () => void
}

export const TermsModal: React.FC<TermsModalProps> = ({
  requiredToAccept,
  onAccept,
  onClose,
}) => {
  const { t } = useLingui()
  return (
    <Dialog.Root
      open
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose()
      }}>
      <Dialog.Portal>
        <ModalOverlay $requiredToAccept={requiredToAccept}>
          <ModalContent
            aria-describedby={undefined}
            onEscapeKeyDown={
              requiredToAccept ? (event) => event.preventDefault() : undefined
            }
            onInteractOutside={(event) => event.preventDefault()}>
            <CantileverCard>
              <CantileverCard.CardHeader
                sticky
                leadingContent={
                  <Dialog.Title asChild>
                    <span>{t`Cantilever Terms of Service`}</span>
                  </Dialog.Title>
                }
                trailingContent={
                  !requiredToAccept && (
                    <CantileverButton
                      aria-label={t`Close terms of service`}
                      ghost
                      iconOnly
                      onClick={onClose}>
                      <X size={20} />
                    </CantileverButton>
                  )
                }
                subContent={
                  requiredToAccept
                    ? t`You must accept the terms to continue.`
                    : undefined
                }
              />
              <CantileverCard.Section
                bottomBorder
                style={{
                  height: '70vh',
                  overflowY: 'auto',
                }}>
                <TermsContent />
              </CantileverCard.Section>
              {requiredToAccept && (
                <CantileverCard.Section topPadding bottomPadding>
                  <AcceptButton primary onClick={onAccept}>
                    {t`Accept Terms`}
                  </AcceptButton>
                </CantileverCard.Section>
              )}
            </CantileverCard>
          </ModalContent>
        </ModalOverlay>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
